module.exports = require('./wrapOnClick')
